import React, { useState } from 'react'
import { useTheme } from '../hooks/useTheme'

const IconButton = ({
  children,
  onClick,
  style,
  disabled = false,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const theme = useTheme()

  // Get button styles based on size and color
  const getButtonStyles = () => {
    const baseStyles = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      boxSizing: 'border-box',
      outline: 0,
      border: 0,
      margin: 0,
      padding: '7px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      userSelect: 'none',
      verticalAlign: 'middle',
      textDecoration: 'none',
      color: disabled ? theme.palette.action.disabled : 'inherit',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      fontWeight: 400,
      lineHeight: 1,
      letterSpacing: '0em',
      textTransform: 'none',
      borderRadius: '50%',
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
    }

    return {
      ...baseStyles,
      ...style
    }
  }

  const styles = getButtonStyles()

  return (
    <button
      onClick={onClick}
      type='button'
      style={styles}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  )
}

IconButton.displayName = 'IconButton'

export default IconButton
